<template>
  <edit></edit>
</template>

<script>
import edit from './uniapp_version_edit.vue'
export default {
  name: 'uniapp_version_edit',

  components: {
    edit
  }
}
</script>